import { Component, Input } from "@angular/core"
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"
import { SearchInfoModel } from "../../models/searchInfo.model"
import { FacetingService } from "../../services/faceting.service"
import { MobileFilterModalComponent } from "../modals/mobile-filter-modal/mobile-filter-modal.component"

@Component({
    selector: "app-mobile-search-top-section",
    templateUrl: "./mobile-search-top-section.component.html",
    styleUrls: ["./mobile-search-top-section.component.less"],
})
export class MobileSearchTopSectionComponent {
    public shouldDisplayAppliedFilters: boolean = false
    public appliedFiltersCount: number = 0

    @Input() public searchInfo?: SearchInfoModel

    constructor(public modalService: NgbModal, public facetingService: FacetingService) {}

    public ngOnInit(): void {
        this.facetingService.filtersChanged.subscribe((data) => {
            if (data) {
                this.appliedFiltersCount = data.length

                if (this.searchInfo) {
                    this.appliedFiltersCount += 1
                }
            }
        })
    }

    public toggleFiltersDisplay(): void {
        this.shouldDisplayAppliedFilters = !this.shouldDisplayAppliedFilters
    }

    public openMobileFilters(): void {
        const modalRef = this.modalService.open(MobileFilterModalComponent)
        modalRef.componentInstance.searchInfo = this.searchInfo
    }
}
